// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/antd/dist/antd.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #fafafa;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/**/
.sidebar-container {

  position: fixed;

}


.sidebar {

  background-color: var(--black);

  width: 3.5rem;

  height: 80vh;

  margin-top: 1rem;

  border-radius: 0 30px 30px 0;

  padding: 1rem 0;

  transition: width 0.5s ease;

}


.sidebar.expanded {

  width: 12rem;

}


.logo img {

  width: 100%;

  height: auto;

}


.menu {

  list-style: none;

  padding: 2rem 0;

  transition: width 0.5s ease;

}


.menu.expanded {

  width: 12rem;

}


.menu li {

  padding-left: 1rem;

}


.menu li a {

  display: flex;

  align-items: center;

}


.menu li a img {

  width: 1.2rem;

  height: auto;

  filter: invert(92%) sepia(4%) saturate(1033%) hue-rotate(169deg) brightness(78%) contrast(85%);

}


.menu li a .show {

  display: block;

  margin-left: 1.5rem;

}


.menu li a .hide {

  display: none;

}


.profile {

  display: flex;

  align-items: center;

  justify-content: center;

  margin-left: 0;

  transition: all 0.3s ease;

}


.profile.expanded {

  width: 14rem;

  margin-left: 9rem;

}


.profile img {

  width: 2.5rem;

  height: 2.5rem;

  border-radius: 50%;

}


.profile .show {

  display: flex;

  justify-content: space-between;

  align-items: center;

}


.profile .hide {

  display: none;

}


.name h4 {

  display: inline-block;

}


.logout img {

  width: 100%;

  height: auto;

  filter: invert(15%) sepia(70%) saturate(6573%) hue-rotate(2deg) brightness(100%) contrast(126%);

  transition: all 0.3s ease;

}


.logout:hover img {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,GAAG;AACH;;EAEE,eAAe;;AAEjB;;;AAGA;;EAEE,8BAA8B;;EAE9B,aAAa;;EAEb,YAAY;;EAEZ,gBAAgB;;EAEhB,4BAA4B;;EAE5B,eAAe;;EAEf,2BAA2B;;AAE7B;;;AAGA;;EAEE,YAAY;;AAEd;;;AAGA;;EAEE,WAAW;;EAEX,YAAY;;AAEd;;;AAGA;;EAEE,gBAAgB;;EAEhB,eAAe;;EAEf,2BAA2B;;AAE7B;;;AAGA;;EAEE,YAAY;;AAEd;;;AAGA;;EAEE,kBAAkB;;AAEpB;;;AAGA;;EAEE,aAAa;;EAEb,mBAAmB;;AAErB;;;AAGA;;EAEE,aAAa;;EAEb,YAAY;;EAEZ,8FAA8F;;AAEhG;;;AAGA;;EAEE,cAAc;;EAEd,mBAAmB;;AAErB;;;AAGA;;EAEE,aAAa;;AAEf;;;AAGA;;EAEE,aAAa;;EAEb,mBAAmB;;EAEnB,uBAAuB;;EAEvB,cAAc;;EAEd,yBAAyB;;AAE3B;;;AAGA;;EAEE,YAAY;;EAEZ,iBAAiB;;AAEnB;;;AAGA;;EAEE,aAAa;;EAEb,cAAc;;EAEd,kBAAkB;;AAEpB;;;AAGA;;EAEE,aAAa;;EAEb,8BAA8B;;EAE9B,mBAAmB;;AAErB;;;AAGA;;EAEE,aAAa;;AAEf;;;AAGA;;EAEE,qBAAqB;;AAEvB;;;AAGA;;EAEE,WAAW;;EAEX,YAAY;;EAEZ,+FAA+F;;EAE/F,yBAAyB;;AAE3B;;;AAGA;EACE,YAAY;AACd","sourcesContent":["@import \"~antd/dist/antd.css\";\n\nbody {\n  background-color: #fafafa;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/**/\n.sidebar-container {\n\n  position: fixed;\n\n}\n\n\n.sidebar {\n\n  background-color: var(--black);\n\n  width: 3.5rem;\n\n  height: 80vh;\n\n  margin-top: 1rem;\n\n  border-radius: 0 30px 30px 0;\n\n  padding: 1rem 0;\n\n  transition: width 0.5s ease;\n\n}\n\n\n.sidebar.expanded {\n\n  width: 12rem;\n\n}\n\n\n.logo img {\n\n  width: 100%;\n\n  height: auto;\n\n}\n\n\n.menu {\n\n  list-style: none;\n\n  padding: 2rem 0;\n\n  transition: width 0.5s ease;\n\n}\n\n\n.menu.expanded {\n\n  width: 12rem;\n\n}\n\n\n.menu li {\n\n  padding-left: 1rem;\n\n}\n\n\n.menu li a {\n\n  display: flex;\n\n  align-items: center;\n\n}\n\n\n.menu li a img {\n\n  width: 1.2rem;\n\n  height: auto;\n\n  filter: invert(92%) sepia(4%) saturate(1033%) hue-rotate(169deg) brightness(78%) contrast(85%);\n\n}\n\n\n.menu li a .show {\n\n  display: block;\n\n  margin-left: 1.5rem;\n\n}\n\n\n.menu li a .hide {\n\n  display: none;\n\n}\n\n\n.profile {\n\n  display: flex;\n\n  align-items: center;\n\n  justify-content: center;\n\n  margin-left: 0;\n\n  transition: all 0.3s ease;\n\n}\n\n\n.profile.expanded {\n\n  width: 14rem;\n\n  margin-left: 9rem;\n\n}\n\n\n.profile img {\n\n  width: 2.5rem;\n\n  height: 2.5rem;\n\n  border-radius: 50%;\n\n}\n\n\n.profile .show {\n\n  display: flex;\n\n  justify-content: space-between;\n\n  align-items: center;\n\n}\n\n\n.profile .hide {\n\n  display: none;\n\n}\n\n\n.name h4 {\n\n  display: inline-block;\n\n}\n\n\n.logout img {\n\n  width: 100%;\n\n  height: auto;\n\n  filter: invert(15%) sepia(70%) saturate(6573%) hue-rotate(2deg) brightness(100%) contrast(126%);\n\n  transition: all 0.3s ease;\n\n}\n\n\n.logout:hover img {\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
